import { createReducer, on } from "@ngrx/store";
import { applicationInitialState } from "../initial-states/application.state";
import { setChipMessage, setCurrentPageId, setNavigationPanelTitle, setTenantAnalyzerBanner, updateNavigationHistory } from "../actions/application.actions";

export const ApplicationReducer = createReducer(applicationInitialState,

	// The reducer runs when a dispatch 'updateNavigationHistory' was triggered
	// This happen when a new navigation the navigation changes on the application
	// The service is responsible for do it and serve the store with the current values
	on(updateNavigationHistory,
		(state, { history }) => ({
			...state, // Copy the existing state
			navigationHistory: { ...history }
		}),
	),


	on(setCurrentPageId,
		(state, { pageId }) => ({
			...state, // Copy the existing state
			pageId
		}),
	),

	on(setNavigationPanelTitle,
		(state, { pageTitle, pageSection }) => ({
			...state, // Copy the existing state
			pageTitle,
			pageSection
		}),
	),

	on(setChipMessage,
		(state, { chipMessage }) => ({
			...state, // Copy the existing state
			chipActive: chipMessage
		})
	),
	on(setTenantAnalyzerBanner,
		(state, { analyzerBanner }) => ({
			...state, // Copy the existing state
			analyzerBanner: analyzerBanner
		})
	)
)
